import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DtoDetail} from "../../../../core/shared/dto/dto.detail";
import {DtoList} from "../../../../core/shared/dto/dto.list";

@Injectable({
  providedIn: 'root'
})
export class TicketTypeActionService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/tm/ticketTypeActions');
  }

  /**
   * Retrieve all TicketActions via the Ticket Type.
   * @param dtoTicketType
   */
  listActionsFromTicketType(dtoTicketType: DtoDetail) : Observable<DtoList> {

    return this.listByAttribute("ticketType", dtoTicketType["id"]);

  }

}
